import React, { FC } from 'react';
import { ISigningAppointmentDashboardResponse } from 'types/signingAppointment/ISigningAppointmentDashboardResponse';
import { convertTimeFromISO, DateFormat, getDateString } from '../../../../ui-toolkit/utilities/getDateString';

const DateTimeCell: FC<{ dateLabel: string; timeLabel: string }> = ({ dateLabel, timeLabel }) => (
  <div className="flex flex-col">
    <p>{dateLabel}</p>
    <p>{timeLabel}</p>
  </div>
);

export const FormattedAppointmentDateTime: FC<{ row: ISigningAppointmentDashboardResponse }> = ({ row }) => {
  if (row.isDigitalScheduling) {
    if (!row.scheduledFor) {
      return <p>Selection Pending</p>;
    }

    return <DateTimeCell dateLabel={getDateLabel(row)} timeLabel={getTimeLabel(row)} />;
  }
  if (!row.appointmentTime) {
    return <p>Selection Pending</p>;
  }

  return <DateTimeCell dateLabel={getDateLabel(row)} timeLabel={convertTimeFromISO(row.appointmentTime, 'HH:mm:ss')} />;
};

export const getDateLabel = (row: ISigningAppointmentDashboardResponse): string => {
  if (!row.appointmentDate) {
    return 'Selection Pending';
  }
  return getDateString(DateFormat.isoDate, row.appointmentDate);
};

export const getTimeLabel = (row: ISigningAppointmentDashboardResponse): string => {
  if (!(row.appointmentTime && row.abbreviatedTimeZone)) {
    return 'Selection Pending';
  }
  return `${convertTimeFromISO(row.appointmentTime, 'HH:mm:ss')} ${row.abbreviatedTimeZone}`;
};
